import { resolveRuntimeConfig } from '~~/package/config/resolveConfig';

/**
 * 온보딩/설문 SDK UMD 스크립트 및 설정 자산의 도메인별 S3 URL을 구성한다.
 *
 * 자산은 `s3://codepresso-onboarding/{domain}/...` 로 업로드되며(onboarding `scripts/upload-s3.mjs`),
 * `{domain}` 은 canonical 도메인(예: `localhost`, `codepresso.io`, `eu.codepresso.io`)만 존재한다.
 * 따라서 `window.location.hostname` 원본(예: `www.codepresso.io`, `127.0.0.1`)을 그대로 쓰면
 * 존재하지 않는 prefix 를 요청해 404 가 난다. 대신 런타임 config(`resolveRuntimeConfig` → run-type 의
 * `SDK_ASSET_DOMAIN`)에서 canonical prefix 를 읽어 host 정규화 규칙을 단일 소스로 공유한다.
 *
 * 클라이언트 전용(`.client.ts` 플러그인)에서만 호출되므로 `window` 접근이 안전하다.
 */
const SDK_BASE_URL = 'https://codepresso-onboarding.s3.ap-northeast-2.amazonaws.com';

/**
 * 현재 host 에 해당하는 canonical SDK/자산 도메인 prefix.
 * 스크립트 URL(`resolveSdkUrl`)과 SDK 의 config 로드(`Survey.observe(options, domain)`)가 같은 prefix 를 보도록
 * 양쪽에서 공유한다. SSR/비브라우저는 hostname 이 비어 `resolveRunType('')` → `live` 로 폴백한다.
 */
export const resolveSdkDomain = (): string => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    return resolveRuntimeConfig(hostname).SDK_ASSET_DOMAIN;
};

export const resolveSdkUrl = (file: string): string => {
    return `${SDK_BASE_URL}/${resolveSdkDomain()}/${file}`;
};
